import axios from "axios";
import apiURI from "./Api";

export default class WhatsAppService {
  async authenticateWhatsApp(token, whatsAppNumber) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/whatsapp/auth/`,
      headers: { Authorization: "Bearer " + token },
      data: {
        whatsAppNumber: whatsAppNumber,
      },
    });

    return response.data;
  }

  async confirmWhatsApp(token, codeConfirmation, id) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/whatsapp/confirm`,
      headers: { Authorization: "Bearer " + token },
      data: {
        codeConfirmation: codeConfirmation,
        id: id,
      },
    });

    return response.data;
  }

  async getConnection(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/whatsapp/getconnection`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async deleteConnection(token, id) {
    const response = await axios({
      method: "delete",
      url: `${apiURI}/whatsapp/deleteconnection`,
      headers: { Authorization: "Bearer " + token },
      params: { id },
    });

    return response.data;
  }
}
